// src/components/Admin/AdminLayout.js
import React, { useContext } from 'react';
import { Link, useLocation, Outlet } from 'react-router-dom';
import UserAvatar from '../UI/UserAvatar';
import { AuthContext } from '../../context/AuthContext';

const AdminLayout = () => {
  const { currentUser } = useContext(AuthContext);
  const location = useLocation();
  const activePath = location.pathname;
  const navItems = [
    { path: '/admin', label: 'Question Received' },
    { path: '/admin/questions-asked', label: 'Questions Asked' },
    { path: '/admin/questions-curated', label: 'Questions Curated' },
    { path: '/admin/account-settings', label: 'Account Settings' },
    { path: '/admin/payment', label: 'Payments' },
  ];

  return (
    <section className="admin">
      <div className="container-main top-xs">
        {/* Navigation Wrapper */}
        <div className="admin-nav">
          {/* Desktop Side Navigation */}
          <div className="side-nav desktop">
            <div className="card">
              <ul>
                <h6>Manage Questions</h6>
                <Link to="/admin">
                  <li className={activePath === '/admin' ? 'active' : ''}>
                    Question Received
                  </li>
                </Link>
                <Link to="/admin/questions-asked">
                  <li className={activePath === '/admin/questions-asked' ? 'active' : ''}>
                    Questions Asked
                  </li>
                </Link>
                <Link to="/admin/questions-curated">
                  <li className={activePath === '/admin/questions-curated' ? 'active' : ''}>
                    Questions Curated
                  </li>
                </Link>
                <h6>Settings</h6>
                <Link to="/admin/account-settings">
                  <li className={activePath === '/admin/account-settings' ? 'active' : ''}>
                    Account
                  </li>
                </Link>
                <Link to="/admin/payment">
                  <li className={activePath === '/admin/payment' ? 'active' : ''}>
                    Payment
                  </li>
                </Link>
              </ul>
            </div>
          </div>

          {/* Mobile Navigation */}
          <div className="mobile-nav mobile">
            <div className="user-profile">
              <UserAvatar avatarUrl={currentUser?.avatarUrl} userName={currentUser?.name} size={40} />
              <h5>{currentUser?.name || "Unknown User"}</h5>
            </div>
            <div className="mobile-admin-nav">
              <nav className="mobile-admin-nav-scroll" aria-label="Admin sections">
                {navItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`mobile-admin-nav-pill${activePath === item.path ? ' is-active' : ''}`}
                  >
                    {item.label}
                  </Link>
                ))}
              </nav>
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="main-content container-fluid">
          <Outlet />
        </div>
      </div>
    </section>
  );
};

export default AdminLayout;
